import {Backdrop, CircularProgress} from "@mui/material";
import {theme} from "../../theme/theme";

const BackdropSpinner = () => {
    return (
        <Backdrop sx={{zIndex: theme.zIndex.drawer + 1}} open={true}>
            <CircularProgress color="primary" />
        </Backdrop>
    )
}

export default BackdropSpinner